module.exports = __webpack_public_path__ + "img/img21.41103c56.png";